import { MAX_PAYMENT_AMOUNT } from '@/constants';

export default Object.freeze({
  BANK_ACCOUNT: Object.freeze({
    MISSING_NAME: 'Please include a response for Account name.',
    NAME_MAX_LENGTH: 'You have exceeded the maximum amount of characters.',
    MISSING_ACC_NUM: 'Please include a response for Account number.',
    ACC_NUM_MIN_LENGTH: 'Please enter a minimum of 6 digits for an account number.',
    BSB_MISSING: 'Please include a response for BSB.',
    BSB_GENERIC_MSG: 'Please enter a 6 digit BSB.',
  }),
  CURRENCY_INPUT: Object.freeze({
    NOT_ACCEPTABLE_AMOUNT: (min = 1, max = MAX_PAYMENT_AMOUNT) => {
      return `We can only accept a value of between $${Number(Number(min).toFixed(2)).toLocaleString()} and $${Number(
        Number(max).toFixed(2),
      ).toLocaleString()}. Please enter another amount within this range.`;
    },
    NOT_ACCEPTABLE_AMT_WITHOUT_MAX_AMT: 'We can only accept a value higher than $1 and lower than the maximum payment allowed. Please enter another amount',
    NOT_VALID_CURRENCY: "We can't accept that input - please remove letters, symbols and/or consecutive spaces.",
  }),
  DECLARATION_MISSING: 'Please include a response for Declaration.',
  GENERIC_ERROR: 'Sorry, something has gone wrong, and we can’t show you all the information. Please try refreshing the page.',
  INVALID_SYMBOLS: "We can't accept that input - please remove any special symbols. (e.g. @!$#)",
  NAME: "We can't accept that input - please remove numbers, symbols and/or consecutive spaces.",
  NAME_ON_CARD: Object.freeze({
    MAX_LENGTH: 'You have exceeded the maximum amount of characters.',
    GENERIC_ERROR: 'Please include a response for Name on card.',
  }),
  PAYMENT_FREQUENCY: Object.freeze({
    MISSING: 'Please include a response for payment frequency.',
    GENERIC_ERROR: 'Please select a payment frequency',
  }),
  PAYMENT_START_DATE_ERROR: Object.freeze({
    DEFAULT: 'You can nominate any date up to 30 days from the start of your cover for your first payment.',
    ONLY_UPTO_28: 'Only dates between 1-28 can be accepted. Please select another date.',
    INVALID_DATE: "We can't accept that input - please remove letters and symbols.",
    PAST_DATE: 'Payment start date cannot be a past date.',
    WITHIN_TWO_DAYS: 'Please enter a date that is at least 2 days from today’s date',
    WITHIN_TWO_DAYS_JOL: 'Please enter a date that is at least 2 days after today’s date.',
  }),
  POSTCODE: 'Please enter a postcode, using only numbers in the format 3000.',
  SUBURB: 'Please provide a response for a suburb name.',
  SUBMIT_API_ERROR: `Sorry we aren't able to retrieve a result. Please try submitting your request again. If you've already done that please contact us on
    <a href="tel:1800 335 425">1800 335 425</a>. Our friendly team will be happy to help you.`,
  SUBMIT_POLICY_API_ERROR: `Sorry, something has gone wrong, and we can’t complete your change. For further assistance, please call <a href="tel:1800 335 425">1800 335 425</a>. Our friendly team will be happy to help you.`,
  SUBMIT_POLICY_CRM_API_ERROR: `Sorry, something has gone wrong, and we can’t complete the change.`,
  SUBMIT_POLICY_IN_PROCESS_ERROR: Object.freeze({
    HEADER: `Sorry, something has gone wrong with your [] request.`,
    SUBHEADER: `Please try again. If you continue to see this message, contact us on <a href="tel:1800 335 425">1800 335 425</a> during business hours.`,
    replacePlaceholder: (string, flowName) => {return string.replace('[]', flowName);},
  }),
  SUBMIT_POLICY_IN_PROCESS_ERROR_CRM: Object.freeze({
    HEADER: `Sorry, something has gone wrong with the [] request.`,
    SUBHEADER: `Please try again. If this error persists, seek assistance.`,
    replacePlaceholder: (string, flowName) => {return string.replace('[]', flowName);},
  }),
});
